import z from 'zod';
import { _ } from 'svelte-i18n';
import { get } from 'svelte/store';

export const validatePassword = () =>
	z
		.string()
		.refine((value) => value.length >= 10, {
			message: get(_)('common.error.min.length', { values: { x: 10 } }),
		})
		.refine((value) => /[0-9]/.test(value), {
			message: get(_)('common.error.min.number'),
		})
		.refine((value) => /[A-Z]/.test(value), {
			message: get(_)('common.error.min.uppercaseletter'),
		})
		.refine((value) => /[a-z]/.test(value), {
			message: get(_)('common.error.min.lowercaseletter'),
		})
		.refine((value) => /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(value), {
			message: get(_)('common.error.min.specialcharacter'),
		});

export const zodTranslatedErrors: z.ZodErrorMap = (issue, ctx) => {
	switch (issue.code) {
		case z.ZodIssueCode.invalid_type:
			if (issue.received === z.ZodParsedType.undefined) {
				return { message: get(_)('common.error.required') };
			}
			break;
		case z.ZodIssueCode.invalid_string:
			if (issue.validation === 'email') {
				return { message: get(_)('common.sign.up.error.email.valid') };
			}
	}
	return { message: ctx.defaultError };
};
